import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class Configuration {
    public ApiUrl = 'api';
    public StaticImageUrl = environment.staticFileEndpoint;
    public ServerApiUrl = environment.apiEndpoint + this.ApiUrl;
    public SocketUrl = environment.socketEndpoint;
    public serverUrl = environment.apiEndpoint;
}
